import { render, staticRenderFns } from "./jiezhen.vue?vue&type=template&id=fc7d983e&scoped=true&"
import script from "./jiezhen.vue?vue&type=script&lang=js&"
export * from "./jiezhen.vue?vue&type=script&lang=js&"
import style0 from "./jiezhen.vue?vue&type=style&index=0&id=fc7d983e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7d983e",
  null
  
)

export default component.exports